var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from "class-transformer";
import { IsArray, IsString, ValidateNested } from "class-validator";
import { safeAssign } from "./safe-assign";
export class GetReplacementCandidatesParams {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsArray(),
    IsString({ each: true }),
    __metadata("design:type", Array)
], GetReplacementCandidatesParams.prototype, "timeEntryIds", void 0);
export class ReplacementCandidateDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ReplacementCandidateDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ReplacementCandidateDTO.prototype, "firstName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ReplacementCandidateDTO.prototype, "lastName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ReplacementCandidateDTO.prototype, "email", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ReplacementCandidateDTO.prototype, "phone", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ReplacementCandidateDTO.prototype, "phone2", void 0);
export class ShiftReplacementDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], ShiftReplacementDTO.prototype, "timeEntryId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ShiftReplacementDTO.prototype, "date", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ShiftReplacementDTO.prototype, "startPlanned", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ShiftReplacementDTO.prototype, "endPlanned", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ShiftReplacementDTO.prototype, "positionName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ShiftReplacementDTO.prototype, "departmentName", void 0);
__decorate([
    Expose(),
    ValidateNested({ each: true }),
    Type(() => ReplacementCandidateDTO),
    __metadata("design:type", Array)
], ShiftReplacementDTO.prototype, "candidates", void 0);
export class GetReplacementCandidatesResponse {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    ValidateNested({ each: true }),
    Type(() => ShiftReplacementDTO),
    __metadata("design:type", Array)
], GetReplacementCandidatesResponse.prototype, "shifts", void 0);
//# sourceMappingURL=replacement-candidates.dto.js.map